import React, { useContext, useEffect } from 'react'
import EditorSDKContext from '../context/EditorSDKContext';
import useEditorType from './useEditorType'
import { getWidth } from '../utils';

export type DisplayType = 'mobile' | 'tablet' | 'desktop';

const useViewPort = () => {
  const editorSDK = useContext(EditorSDKContext);
  const { isEditorX } = useEditorType();
  getWidth()
  useEffect(() => {
    if (!editorSDK) return;

    const getViewport = async () => {
      editorSDK.editor.info.getCurrentViewport().then(data => {
      }).catch(e => console.log('>>> ', e))
    };

    getViewport()
  }, [])
}

export default useViewPort
